import {
  ClonePreviewTabIcon,
  CloneTabIcon,
  DemoPresentTabIcon,
  DemoPreviewTabIcon,
  DemoTabIcon,
  GlobalIcon,
  HomeIcon,
  PlaybookPresentTabIcon,
  PlaybookPreviewTabIcon,
  TourPreviewTabIcon,
  TourTabIcon,
} from '@carboncopyco/icons';
import {
  type IGlobalTab,
  TabGroupName,
  TabType,
} from '@carboncopyco/types/desktop';
import { useState } from 'react';
import { isUrlPDF } from '../../../../util/util';

const TabIcon = ({ tab }: { tab: IGlobalTab }) => {
  const [faviconError, setFaviconError] = useState(false);
  const handleImageError = () => {
    setFaviconError(true);
  };
  switch (tab.type) {
    // HOME
    case TabType.BASIC: {
      return <HomeIcon size={window?.dsDesktop?.app?.isWindows ? 30 : 16} />;
    }
    // CLONE
    case TabType.CLONE_MOBILE_PREVIEW:
    case TabType.CLONE:
    case TabType.UPDATE_CLONE: {
      return <CloneTabIcon size={20} />;
    }
    case TabType.PREVIEW_CLONE: {
      return <ClonePreviewTabIcon size={20} />;
    }
    // DEMO
    case TabType.OVERLAY_NEW:
    case TabType.OVERLAY_EDITOR:
    case TabType.MOBILE_DEMO_EDITOR:
    case TabType.DEMO_EDITOR: {
      return <DemoTabIcon size={20} />;
    }
    case TabType.DEMO_MOBILE_PREVIEW:
    case TabType.PREVIEW_DEMO:
    case TabType.PREVIEW_OVERLAY: {
      return <DemoPreviewTabIcon size={20} />;
    }
    case TabType.DEMO_MOBILE_PRESENTATION:
    case TabType.PRESENTER_DEEPLINK_DEMO:
    case TabType.PRESENT_DEMO: {
      return <DemoPresentTabIcon size={20} />;
    }
    // PLAYBOOK
    case TabType.PRESENTER_DEEPLINK_PLAYBOOK: {
      return <PlaybookPresentTabIcon size={20} />;
    }
    case TabType.GROUP_DEMO_MOBILE_PRESENTATION:
    case TabType.GROUP_DEMO_PRESENTATION: {
      if (!tab.group?.mergingOptions?.isDetached) {
        return <PlaybookPresentTabIcon size={20} />;
      }
      return <DemoTabIcon size={20} />;
    }
    case TabType.GROUP_TOUR_PRESENTATION: {
      if (!tab.group?.mergingOptions?.isDetached) {
        return <PlaybookPresentTabIcon size={20} />;
      }
      return <TourTabIcon size={20} />;
    }
    case TabType.GROUP_DEMO_PREVIEW: {
      if (!tab.group?.mergingOptions?.isDetached) {
        return <PlaybookPreviewTabIcon size={20} />;
      }
      return <DemoTabIcon size={20} />;
    }
    case TabType.GROUP_TOUR_PREVIEW: {
      if (!tab.group?.mergingOptions?.isDetached) {
        return <PlaybookPreviewTabIcon size={20} />;
      }
      return <TourTabIcon size={20} />;
    }
    // TOUR
    case TabType.TOURS_CREATE:
    case TabType.LIVE_TOURS_CREATE:
    case TabType.TOURS_EDITOR: {
      return <TourTabIcon size={20} />;
    }
    case TabType.TOURS_PREVIEW: {
      return <TourPreviewTabIcon size={20} />;
    }
    // BROWSER WINDOW
    case TabType.BROWSER_WINDOW: {
      if (
        tab.group?.mergingOptions?.allowed &&
        !tab.group.mergingOptions.isDetached
      ) {
        return tab.group?.name === TabGroupName.PlaybookPreview ? (
          <PlaybookPreviewTabIcon size={20} />
        ) : (
          <PlaybookPresentTabIcon size={20} />
        );
      }
      if (!faviconError && tab.favicon && !isUrlPDF(tab?.url)) {
        return (
          <span className="w-4 h-4">
            <img
              alt="favicon"
              src={tab.favicon}
              onError={handleImageError}
            />
          </span>
        );
      }
      return <GlobalIcon size={19} />;
    }
    default:
      return null;
  }
};
export default TabIcon;
